// extracted by mini-css-extract-plugin
export default {"wrapper":"Wrapper_wrapper__Y+qdt","card":"Wrapper_card__jiaZ2","title":"Wrapper_title__01b8h","content":"Wrapper_content__N7TMM","tabs":"Wrapper_tabs__Y5wAf"};